import { SVGProps } from 'react';

const HsaSuccessDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={34}
    height={52}
    viewBox="0 0 34 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M33.7277 34.3349C33.7277 23.2744 9.77654 18.7101 7.37311 10.628C7.27304 10.2158 7.22385 9.7918 7.23572 9.3559C9.49159 8.74529 12.2495 8.49426 15.6842 8.61129L16.0268 8.62316C16.5356 8.64013 17.2752 8.6961 18.0622 8.89624C19.4852 9.46954 20.8065 10.7094 20.8065 13.374C20.8845 17.1564 24.3531 18.5744 27.0313 18.5744C30.1828 18.5744 32.3114 17.628 32.3114 15.2652C32.3114 14.5206 32.1231 13.8405 31.7856 13.2231C29.9758 9.25922 22.2279 7.57325 16.6188 7.3358V0L15.4179 0V7.30866C15.2415 7.30866 15.0668 7.30866 14.8972 7.30866C4.65081 7.31035 0.317178 10.935 0.317178 17.0801C0.317178 17.1513 0.32057 17.2226 0.322266 17.2938C0.32057 17.3803 0.317178 17.4634 0.317178 17.5499C0.317178 30.539 25.0604 33.8973 27.067 41.8471C24.9078 42.6477 22.2415 43.0836 19.068 43.0836C10.4804 43.0836 2.17275 38.0071 1.19917 33.4733V33.4258H0L0 42.2491H1.19747V36.7807C3.30577 40.3325 8.9573 43.7841 15.4145 44.7441V51.6491H16.6154V44.8917C17.3735 44.9663 18.1419 45.007 18.9136 45.007C28.602 45.007 33.7243 40.9125 33.7277 34.7691L33.7158 34.7827C33.7226 34.6334 33.7277 34.4842 33.7277 34.3332V34.3349Z"
      fill="#FFFEF6"
    />
  </svg>
);

export default HsaSuccessDollar;
